import React from 'react';
import Hero from '../components/ui/Hero';
import ServiceCard from '../components/ui/ServiceCard';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { ClipboardDocumentCheckIcon, PresentationChartLineIcon, AcademicCapIcon } from '@heroicons/react/24/outline';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      
      {/* Serviços */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">Nossos Serviços</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            <ServiceCard 
              title="Auditoria de Processos" 
              description="Avaliação de conformidade com normas ISO"
              icon={<ClipboardDocumentCheckIcon className="h-8 w-8 sm:h-10 sm:w-10" />}
            />
            <ServiceCard 
              title="Consultoria Técnica" 
              description="Implantação de sistemas de gestão da qualidade"
              icon={<PresentationChartLineIcon className="h-8 w-8 sm:h-10 sm:w-10" />}
            />
            <ServiceCard 
              title="Treinamentos" 
              description="Cursos, workshops e palestras sobre normas e boas práticas"
              icon={<AcademicCapIcon className="h-8 w-8 sm:h-10 sm:w-10" />}
            />
          </div>
          <div className="text-center mt-8 sm:mt-12">
            <Link to="/servicos">
              <Button variant="primary">Ver todos os serviços</Button>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Por que escolher */}
      <section className="py-12 sm:py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">Por que escolher a Aristia?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-white p-5 sm:p-6 rounded-lg shadow">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Experiência Comprovada</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Com anos de atuação em sistemas de gestão, nossa consultoria acumula vivência prática em diversos setores, 
                garantindo soluções eficazes e alinhadas às melhores práticas nacionais e internacionais.
              </p>
            </div>
            <div className="bg-white p-5 sm:p-6 rounded-lg shadow">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Certificações</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Estamos sempre atualizados com as normas ISO 9001, ISO 14001, ISO 45001 e ISO 27001, oferecendo suporte técnico completo para certificações, recertificações e auditorias internas com excelência.
              </p>
            </div>
            <div className="bg-white p-5 sm:p-6 rounded-lg shadow">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Abordagem Personalizada</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Cada empresa é única — por isso, desenvolvemos estratégias sob medida, respeitando a cultura organizacional, os objetivos específicos e o estágio de maturidade de cada cliente.
              </p>
            </div>
            <div className="bg-white p-5 sm:p-6 rounded-lg shadow">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Resultados Comprovados</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Nossos projetos geram impacto real: melhoria de processos, redução de riscos, aumento da conformidade e fortalecimento da reputação das empresas que atendemos.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA */}
      <section className="py-12 sm:py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Pronto para elevar a qualidade do seu negócio?</h2>
          <p className="text-base sm:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e descubra como podemos ajudar sua empresa a 
            alcançar a excelência em gestão da qualidade.
          </p>
          <Link to="/contato">
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/20">
              Entre em contato
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
